import React, { FC } from 'react';

type AppGroupProps = {
    title?: string;
    col?: number
    children?: React.ReactNode;
}

const AppGroup: FC<AppGroupProps> = (props) => {
  return (
    <div className={`col-xs-${props.col || 12}`}>
      <div className="ml-1 mr-1">
        { props.title ? <span className="dx-form-group-caption">{ props.title }</span> : null}
        <div className={`dx-form-group-content ${props.title ? 'dx-form-group-content--border' : '' }`}>
          { props.children }
        </div>
      </div>
    </div>
  );
};


export default AppGroup;
